var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './UserSelector.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { SonarUser } from './SonarUser';
import { useUsers } from '@hooks';
import React, { useMemo } from 'react';
import { SonarSelector } from './SonarSelector';
export const UserSelector = (_a) => {
    var { avatar, className, onSingleChange, onMultipleChange, selectionRequired, placeholder, popupClassName, value, withLatest } = _a, props = __rest(_a, ["avatar", "className", "onSingleChange", "onMultipleChange", "selectionRequired", "placeholder", "popupClassName", "value", "withLatest"]);
    const users = useUsers(withLatest);
    const placeholderNode = useMemo(() => React.createElement(SonarUser, { avatar: avatar, placeholder: placeholder, userId: -1 }), [avatar, placeholder]);
    const options = useMemo(() => {
        const userOptions = users === null || users === void 0 ? void 0 : users.filter((user) => !user.isLocked || user.id === value).map((user) => {
            var _a, _b;
            return ({
                className: classNames({
                    disabled: user.isReadOnly || user.isLocked
                }),
                disabled: user.isReadOnly || user.isLocked,
                label: React.createElement(SonarUser, { avatar: avatar, userId: (_a = user === null || user === void 0 ? void 0 : user.id) !== null && _a !== void 0 ? _a : -1 }),
                optionLabel: React.createElement(SonarUser, { avatar: avatar, showTooltip: true, userId: (_b = user === null || user === void 0 ? void 0 : user.id) !== null && _b !== void 0 ? _b : -1 }),
                searchValue: user.fullName,
                value: user.id
            });
        });
        if (value && !selectionRequired) {
            return [
                {
                    label: React.createElement(SonarUser, { avatar: avatar, placeholder: COPY_SPECIFIC.NO_OWNER, userId: -1 }),
                    searchValue: '',
                    value: -1
                },
                ...userOptions
            ];
        }
        return userOptions;
    }, [avatar, selectionRequired, users, value]);
    const handleOnChange = (changeValue) => {
        if (Array.isArray(changeValue) && onMultipleChange) {
            onMultipleChange(changeValue);
            return;
        }
        if (!onSingleChange) {
            return;
        }
        if (!changeValue || changeValue === -1) {
            onSingleChange(undefined);
        }
        else {
            onSingleChange(changeValue);
        }
    };
    return React.createElement(SonarSelector, Object.assign({}, props, { className: classNames('user-selector', className), onChange: handleOnChange, options: options, placeholder: placeholderNode, popupClassName: classNames('space-conscious-owner-label', popupClassName), readOnlyDisplay: value ? React.createElement(SonarUser, { placeholder: COPY_SPECIFIC.NO_OWNER, showTooltip: true, userId: Number(value) }) : null, showArrow: true, value: value }));
};
